import { render, staticRenderFns } from "./GenericListedMovies.vue?vue&type=template&id=07f63aa0&scoped=true"
import script from "./GenericListedMovies.vue?vue&type=script&lang=js"
export * from "./GenericListedMovies.vue?vue&type=script&lang=js"
import style0 from "./GenericListedMovies.vue?vue&type=style&index=0&id=07f63aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f63aa0",
  null
  
)

export default component.exports